//Please add the language resource
const mat = {
  skuCode: 'skuCode',
  skuName: 'skuName',
  shipperCode: 'shipperCode',
  shipperName: 'shipperName',
  skuLength: 'skuLength',
  skuWidth: 'skuWidth',
  skuHeight: 'skuHeight',
  unitVolume: 'unitVolume',
  unitWeight: 'unitWeight',
  unitNetWeight: 'unitNetWeight',
  unit: 'unit',
  activeOff: 'activeOff',
  useCompanyCode: 'useCompany',
  useCompanyName: 'useCompanyName',
  isDefault: '是否默认',
  msg: {
    msg: {
      skuCode : 'Please input skuCode',
      skuName : 'Please input skuName',
      isDefault: '请选择是否默认',
      shipperCode : 'Please select shipperName',
      activeOff: 'Please input activeOff'
    }
  }
};
export default mat



// WEBPACK FOOTER //
// ./src/page/mdm/mat/lang/mat.en.js